import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useContext } from "react";
import { css } from "styled-components";

export interface OrderDetailsDeliveryMethodStyles {
    titleText?: TypographyProps;
    wrapper?: InjectableCss;
    infoWrapper?: InjectableCss;
    text?: TypographyProps;
}

export const orderDetailsDeliveryMethodStyles: OrderDetailsDeliveryMethodStyles = {};

const styles = orderDetailsDeliveryMethodStyles;

const OrderDetailsDeliveryMethod: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper} data-test-selector="orderDetailShippingInformation">
            <Typography {...styles.titleText}>{translate("Delivery Method")} </Typography>
            <StyledWrapper {...styles.infoWrapper}>
                {order.properties["carrierDescription"] && (
                    <Typography {...styles.text}>{order.properties["carrierDescription"]}</Typography>
                )}
                {order.shipViaDescription && <Typography {...styles.text}>{order.shipViaDescription}</Typography>}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsDeliveryMethod,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
